module.exports = __webpack_public_path__ + "static/media/bravo_leo.789e70b7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/gif/bravo_leo.gif
// module id = 701
// module chunks = 0